<template>
  <div class="commentPage">
    <Navbar title="评论" :backNative="true" />
    <van-pull-refresh
      v-model="refreshing"
      style="min-height: 100vh"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="comment_content">
          <div
            class="comment_card"
            v-for="(item, index) in list"
            :key="index"
            @click="toDetail(item)"
          >
            <div class="card_left">
              <img
                :src="
                  item.commentsMemberAvatar
                    ? item.commentsMemberAvatar
                    : require('../../assets/images/default.png')
                "
                alt=""
              />
            </div>
            <div class="card_right">
              <div class="comment_info">
                <div class="username">{{ item.commentsMemberName }}</div>
                <div class="work_word">
                  评论了你的作品：{{ item.workTitle }}
                </div>
                <div class="comment_word">{{ item.content }}</div>

                <div class="comment_time">{{ item.releaseTime }}</div>
              </div>
              <div class="work_cover">
                <img :src="item.workImage" alt="" />
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import http from "../../utils/http";
import store from "../../store/index";
export default {
  data() {
    return {
      size: 20,
      current: 1,
      list: [],
      loading: false, //是否正在加载
      finished: false, //是否结束
      refreshing: false, //是否正在刷新
    };
  },
  mounted() {
    // this.initPage()

    this.$nextTick(() => {
      if (this.isInit) {
        //获取用户自学剩余时间
        this.initPage();
      }
    });
  },
  methods: {
    initPage() {
      this.init = true;
      this.current = 1;
      //  this.list=[]
      this.getComments();
    },
    onLoad() {
      if (this.refreshing) {
      } else {
        this.current++;
      }

      this.getComments();
    },
    getComments() {
      //   let query = this.$route.query;
      http
        .getSysWorkNotice({
          type: 1,
          size: this.size,
          current: this.current,
        })
        .then((res) => {
          setTimeout(() => {
            if (res.length > 0) {
              if (this.refreshing || this.current == 1) {
                this.list = [...res];
                this.refreshing = false;
              } else {
                this.list = [...this.list, ...res];
              }
              this.loading = false;
            } else {
              this.finished = true;
              this.current--;
            }
          }, 500);
          this.detail = res;
        });
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.current = 1;
      this.onLoad();
    },
    toDetail(item) {
      if (item.classType != null) {
        this.$router.push({
          path: "/workDetail",
          query: { id: item.memberWorkId, type: item.classType },
        }).then(res=>window.PushToken(this.$store.state.token));
      } else {
        this.$router.push({
          path: "/notesDetail",
          query: { id: item.memberWorkId },
        }).then(res=>window.PushToken(this.$store.state.token));
      }
      http.getMessege({ id: item.id });
      
      // this.$refs.child.initPage && this.$refs.child.initPage();

      //     http.getUserSelfStudyTime().then(res=>{

      //     localStorage.setItem('userInfo',JSON.stringify(res))
      // })
    
    },
  },
  components: {
    Navbar,
  },
};
</script>

<style lang="less" scoped>
.commentPage {
  width: 100%;
  .comment_content {
    width: calc(100% - 32px);
    margin: 0 auto;
    .comment_card {
      display: flex;
      margin-top: 16px;
      .card_left {
        width: 40px;
        height: 40px;

        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
        }
      }
      .card_right {
        flex: 1;
        margin-left: 12px;
        display: flex;
        border-bottom: 1px solid rgba(34, 32, 48, 0.1);
        padding-bottom: 16px;
        .comment_info {
          flex: 1;
          .username {
            font-size: 15px;
            color: #222030;
            font-weight: 400;
          }
          .work_word {
            font-size: 13px;
            color: rgba(34, 32, 48, 0.45);
            width: 227px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-top: 4px;
          }
          .comment_word {
            padding: 8px;
            background: #f6f6f6;
            color: #222030;
            font-size: 13px;
            margin-top: 8px;
            word-break: break-all;
          }
          .comment_time {
            font-size: 11px;
            color: rgba(34, 32, 48, 0.25);
            margin-top: 12px;
          }
        }
        .work_cover {
          img {
            width: 52px;
            height: 52px;
            border-radius: 4px;
            object-fit: cover;
          }
          width: 52px;
          height: 52px;
          margin-left: 12px;
        }
      }
      // justify-content: space-between
    }
  }
}
</style>

